import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onInitializeLPC = action('onInitializeLPC', event => ({
    event,
    owaType: 'initializeLPC',
})) as OwaNovaActionUnion<'initializeLPC'>;
